import { useSelector } from 'react-redux';
import { selectIsBaseDataFetch } from '../../selectors';

export const useBaseDataFetched = (): boolean => {
  const isBaseDataFetch = useSelector(selectIsBaseDataFetch);

  return isBaseDataFetch;
};
